import { render, staticRenderFns } from "./TransactionCategoryDetail.vue?vue&type=template&id=307693b9"
import script from "../../../controllers/custom/transaction_category/transaction-category-detail.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/transaction_category/transaction-category-detail.js?vue&type=script&lang=js&external"
import style0 from "./TransactionCategoryDetail.vue?vue&type=style&index=0&id=307693b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports